<template>
  <AppBar color="green" dark>
    <template v-slot:left-side>
      <NavigationButtons />

      <v-toolbar-title>Strona Główna</v-toolbar-title>

      <HomeBreadcrumb />
    </template>
    <template v-slot:right-side>
      <AccountBar />
    </template>
  </AppBar>
</template>

<script>
import AppBar from '@/components/shared/AppBar.vue';
import AccountBar from '@/components/shared/AccountBar.vue';
import NavigationButtons from '@/components/shared/NavigationButtons.vue';
import HomeBreadcrumb from '@/components/breadcrumbs/HomeBreadcrumb.vue';

export default {
  components: {
    AppBar,
    AccountBar,
    NavigationButtons,
    HomeBreadcrumb
  }
};
</script>
